export enum Status {
  LOADING = "LOADING",
  AUTHORIZED = "AUTHORIZED",
  UNAUTHORIZED = "UNAUTHORIZED",
  ERRORED = "ERRORED"
}

export default { Status };
